import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Banners from "@/pages/Banners.vue";
import Login from "@/pages/Login.vue";
import Typography from "@/pages/Typography.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import UpgradeToPRO from "@/pages/UpgradeToPRO.vue";
import Promotions from "../pages/Promotions.vue";
import Contacts from "../pages/Contacts.vue";
import Socialmedia from "../pages/Socialmedia.vue";
import Licence from "../pages/Licence.vue";
import PrivacyPolicy from "../pages/PrivacyPolicy.vue";
import CnR from "../pages/CnR.vue";
import TnC from "../pages/TnC.vue";
import Bonus from "../pages/Bonus.vue";
import Important from "../pages/ImportantInfo.vue";

import ResponsibleGamming from "../pages/ResponsibleGamming.vue";
import Faq from "../pages/Faq.vue";
import TermsAffiliates from "../pages/TermsAffiliates.vue";
import AppNotifications from "../pages/AppNotifications.vue";
import MetaData from '../pages/MetaData.vue'
import SchemaPage from '../pages/SchemaPage.vue'
import PopUps from '../pages/Popups.vue'


const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/login",
    children: [
      {
        path: "banners",
        name: "Banners",
        component: Banners,
        beforeEnter: (to, from, next) => {
          // Prevent navigation to the same route
          if (to.path === from.path) {
            next(false); // Cancels the navigation
          } else {
            next(); // Proceed to the route
          }
        }
      },
      {
        path: '/meta-data',
        name: 'MetaData',
        component: MetaData,
      },
      {
        path: '/meta-data/page/:id',
        name: 'SchemaPage',
        component: SchemaPage,
      },
      
      {
        path: "promotions",
        name: "Promotions",
        component: Promotions,
      },
      {
        path: "app-notifications",
        name: " App Notifications",
        component: AppNotifications,
      },
      {
        path: "pop-ups",
        name: " Pop Ups ",
        component: PopUps,
      },
      {
        path: "affiliates-terms-and-conditions",
        name: "Affiliates",
        component: TermsAffiliates,
      },
      {
        path: "contacts",
        name: "Contacts",
        component: Contacts,
      },
      {
        path: "social-media-handles",
        name: "Social Media Handles",
        component: Socialmedia,
      },
      {
        path: "typography",
        name: "Typography",
        component: Typography,
      },
      {
        path: "icons",
        name: "Icons",
        component: Icons,
      },
      {
        path: "maps",
        name: "Maps",
        meta: {
          hideFooter: true,
        },
        component: Maps,
      },
      // {
      //   path: "notifications",
      //   name: "Notifications",
      //   component: Notifications,
      // },
      {
        path: "upgrade",
        name: "Upgrade to PRO",
        component: UpgradeToPRO,
      },
      {
        path: "licence",
        name: "Licence Number",
        component: Licence,
      },
      {
        path: "privacy-policy",
        name: "Privacy Policy",
        component: PrivacyPolicy,
      },
      {
        path: "conflicts-and-resolutions",
        name: "Conflicts and Resolutions",
        component: CnR,
      },
      {
        path: "terms-and-conditions",
        name: "Terms and Conditions",
        component: TnC,
      },
      {
        path: "bonus-policy",
        name: "Bonus Policy",
        component: Bonus,
      },
      {
        path: "important-info",
        name: "Important Info",
        component: Important,
      },
      {
        path: "responsible-gamming",
        name: "Responsible Gamming",
        component: ResponsibleGamming,
      },
      {
        path: "faq",
        name: "Frequently Asked Questions",
        component: Faq,
      },
    ],
  },
  
  { path: '/login', 
    name: 'CMS', 
    component: Login, },
];

export default routes;
